import { useTranslation } from 'next-i18next'
import CountUp from 'react-countup'

import { StandAloneBuildingSearch } from '@/components/building-search/stand-alone-building-search'
import { Portal } from '@/components/portal'

import {
  AlbertaBlog,
  AlbertaComparison,
  AlbertaCta,
  AlbertaFeatures,
  AlbertaHero,
  AlbertaOtherFeatures,
  AlbertaStats
} from '../../../devlink'

const promotionId = 'ALBERTA'

const AlbertaLandords = () => {
  const { t } = useTranslation()
  const heroPlaceholder = t(
    'landlords:Enter Listing Address',
    'Enter Listing Address'
  )
  const placeholder = t('landlords:Listing Address', 'Listing Address')
  const buttonText = t('landlords:Post a listing', 'Post a listing')
  return (
    <>
      <Portal targetId="alberta_hero-cta-form">
        <StandAloneBuildingSearch
          promotionId={promotionId}
          placeholder={heroPlaceholder}
          buttonText={buttonText}
          trackingId="abgrowthfree_page_click_starthere"
        />
      </Portal>
      <Portal targetId="alberta_features-cta-form">
        <StandAloneBuildingSearch
          promotionId={promotionId}
          placeholder={placeholder}
          buttonText={buttonText}
          trackingId="abgrowthfree_page_click_postalisting"
        />
      </Portal>
      <Portal targetId="alberta_stats-cta-form">
        <StandAloneBuildingSearch
          promotionId={promotionId}
          placeholder={placeholder}
          buttonText={buttonText}
          trackingId="abgrowthfree_page_click_postalisting_2"
        />
      </Portal>
      <div className="webflow-page">
        <AlbertaHero />
        <AlbertaFeatures />
        <AlbertaOtherFeatures />
        <AlbertaComparison />
        <AlbertaStats
          visitsCountText={<CountUp start={0} end={287} enableScrollSpy />}
          tenantsCountText={<CountUp start={0} end={180} enableScrollSpy />}
          signupsCountText={<CountUp start={0} end={2600} enableScrollSpy />}
        />
        <AlbertaCta />
        <AlbertaBlog />
      </div>
    </>
  )
}

export default AlbertaLandords
